import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthContextProvider } from './context/AuthContext';
import { BaseUrlProvider } from './context/BaseUrlContext';
import { CategoryProvider } from 'src/context/CategoriesApi';
import { TagProvider } from 'src/context/ProductTagApi';
import './index.css';

//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <AuthContextProvider>
        <BaseUrlProvider>
          <CategoryProvider>
            <TagProvider>
              <App />
            </TagProvider>
          </CategoryProvider>
        </BaseUrlProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
